<script setup>
import { trans } from '@elements/translation';
import Panel from '@molecules/components/Panel.vue';
</script>

<template>
  <div class="infos-stripe-slider">
    <panel
      type="info"
      class="infos-stripe-slider__panel"
      :content-list="[ trans('gestion.invoices.slider.infos_invoices.content') ]"
      icon="ph_lightbulb-fill_blue"
    />

    <div class="infos-stripe-slider__action">
      <button class="btn btn--white" @click="$emit('close')">
        {{ trans('gestion.invoices.slider.infos_invoices.understood') }}
      </button>
    </div>
  </div>
</template>
